<template>
  <div class="gp-tabs" :class="tabsClass">
    <slot name="GpTabHeader" :activeIndex="activeIndex" :handler="handler" v-if="header"></slot>
    <slot name="GpTabsNav" :activeIndex="activeIndex" :handler="handler" v-if="customNav"></slot>
    <div class="gp-tabs-nav" ref="nav" v-else :style.sync="navStyles">
      <slot name="GpTab" :activeIndex="activeIndex" :handler="handler" />
    </div>

    <div class="gp-tabs-content" v-if="!customBody">
      <slot name="GpTabContent" :activeIndex="activeIndex" :animate="animate" />
    </div>
    <slot name="GpTabsContent" :activeIndex="activeIndex" :animate="animate" v-else></slot>
  </div>
</template>

<script>
export default {
  name: "GpTabs",
  props: {
    tClass: String,
    verticle: {
      type: Boolean,
      default: false
    },
    customNav: {
      type: Boolean,
      default: false
    },
    customBody: {
      type: Boolean,
      default: false
    },
    navStyles: String,
    active: {
      type: [String, Number],
      default: 0
    },
    header: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeIndex: 0,
      animate: "next"
    };
  },
  computed: {
    tabsClass() {
      let classData = [];
      if (this.verticle) {
        classData.push("verticle");
      }
      if (this.tClass) {
        classData.push(this.tClass);
      }
      return classData;
    }
  },
  watch: {
    active(index) {
      if (this.activeIndex != index) {
        this.activeIndex = index;
      }
    }
  },
  created() {
    this.activeIndex = this.active;
  },
  methods: {
    handler(index) {
      if (index < this.activeIndex) {
        this.animate = "prev";
      }
      if (index > this.activeIndex) {
        this.animate = "next";
      }

      if (this.activeIndex != index) {
        this.activeIndex = index;
        this.$emit("tabChange", this.activeIndex);
      }
    }
  }
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>
